import type { TaxonomyCategory } from "../../caseFiles/types";

/** Names the attorney never adds by hand (Organize makes Unclassified itself). */
const HIDDEN = new Set(["unclassified", "exhibit", "packet"]);

/**
 * Unused CaseBlink category names for a parent: filing order, internals and
 * Unclassified / Exhibit / Packet hidden, names already used as a sibling
 * or as the parent itself skipped (case-insensitive).
 */
export const unusedCategoryNames = (
  categories: TaxonomyCategory[],
  taken: readonly string[]
): string[] => {
  const used = new Set(
    taken.map((name) => name.trim().toLowerCase()).filter(Boolean)
  );
  return categories
    .filter((row) => !row.internal)
    .map((row) => row.category)
    .filter((name) => {
      const key = name.trim().toLowerCase();
      return Boolean(key) && !HIDDEN.has(key) && !used.has(key);
    });
};

/** Type-to-filter: names whose text contains the query, in the same order. */
export const filterCategoryNames = (
  names: readonly string[],
  query: string
): string[] => {
  const q = query.trim().toLowerCase();
  if (!q) return [...names];
  return names.filter((name) => name.toLowerCase().includes(q));
};
